export default "__VITE_ASSET__CXtHin_c__"